import PropTypes from 'prop-types';
import React from 'react';

import { PRIMARY_BLUE } from '@wetransfer/transfer/constant/colors';

const Share = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 14V17C5 18.6569 6.34315 20 8 20H16C17.6569 20 19 18.6569 19 17V14M12 15V4M12 4L7 9M12 4L17 9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Share.propTypes = {
  color: PropTypes.string,
};

Share.defaultProps = {
  color: PRIMARY_BLUE,
};

export default Share;
